import React, { useState, useEffect } from "react";
import "./styles.css";
import axios from "axios";
import useAppData from "@/store/useAppData";
import useRouter from "@/store/useRouter";
import { useShallow } from "zustand/shallow";
import { RouterStoreItemKey } from "@/store/useRouter/types";
import logoAirlines from "./logoAirlines.png"
import { Module } from "../ItemList/types";
import Card from "../Card";

const SelectModule: React.FC = () => {

    const loggedUser = useAppData(state => state.user);
    const setLoggedUser = useAppData(state => state.setUser);
    const [modulesState, setModulesState] = useState<Module[]>([]);
    const setSelectedModule = useAppData(state => state.setSelectedModule);

    const go = useRouter(state => state.go);

    useEffect(() => {
        loadModules();
    }, []);

    const loadModules = async () => {
        try {
            const res = await (
                axios({
                    method: "post",
                    url: "api/module/getAll",
                    data: {
                        userId: loggedUser?.id
                    }
                })
            );

            if (res?.data?.modules?.length === 1) {

                if (res.data.modules[0]?.code === "ODMRAZ") {
                    go({ key: RouterStoreItemKey.SELECTROLE });
                } else {
                    go({ key: RouterStoreItemKey.LISTITEMS });
                }

                setSelectedModule(res.data.modules[0]);
            }

            setModulesState(res.data.modules ?? []);
        } catch (err) {
            throw err;
        }
    };

    return (
        <Card
            title="Výběr modulu"
            displaySelectedStock={false}
        >
            {modulesState.map(module => <button
                type="button"
                className="select-module-button"
                onClick={() => {
                    setSelectedModule(module);

                    if (module?.code === "ODMRAZ") {
                        go({ key: RouterStoreItemKey.SELECTROLE });
                    } else {
                        go({ key: RouterStoreItemKey.LISTITEMS });
                    }
                }}
            >
                {module?.name}
            </button>)
            }
        </Card>
    );
};

export default SelectModule;